import { paths, components } from "@securityjourney/svc-integrations/dist/gen/cwes";
import { ServiceClient, TokenFunc, Call, ServiceError } from "@securityjourney/service-client";

export type CWE = components["schemas"]["securityjourney.proto.integrations.CWE"];
export type CWEsResponse = components["schemas"]["securityjourney.proto.integrations.CWEsResponse"];
export type RecordCWERequest =
  components["schemas"]["securityjourney.proto.integrations.RecordCWERequest"];
export type RecordCWEResponse =
  components["schemas"]["securityjourney.proto.integrations.RecordCWEResponse"];
export type CWEFilterOptions =
  components["schemas"]["securityjourney.proto.integrations.CWEFilterOptions"];
export type ExportCWEsResponse =
  components["schemas"]["securityjourney.proto.integrations.ExportCWEsResponse"];
export type CWEReportResponse =
  components["schemas"]["securityjourney.proto.integrations.CWEReportResponse"];
export type CWEFrequencyStat =
  components["schemas"]["securityjourney.proto.integrations.CWEFrequencyStat"];
export type CWETimelineStat =
  components["schemas"]["securityjourney.proto.integrations.CWETimelineStat"];
export type CWEContributorStat =
  components["schemas"]["securityjourney.proto.integrations.CWEContributorStat"];
export type TimelineGranularity =
  components["schemas"]["securityjourney.proto.integrations.TimelineGranularity"];

export class IntegrationsClient extends ServiceClient<paths> {
  constructor(getToken: TokenFunc, url?: string) {
    super({ getToken, url });
  }

  getCWEs(req: {
    tenant: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortOrder?: string;
    emails?: string[];
    cwes?: number[];
    dateFrom?: string;
    dateTo?: string;
  }): Call<CWEsResponse> {
    const func = this.fetcher.path("/svc/integrations/{tenant}/cwes").method("get").create();
    const args = {
      tenant: req.tenant,
      pageSize: req.pageSize,
      page: req.page,
      sortBy: req.sortBy,
      sortOrder: req.sortOrder,
      emails: req.emails,
      cwes: req.cwes,
      dateFrom: req.dateFrom,
      dateTo: req.dateTo,
    };

    const { init, abort } = this.withAbort();
    return {
      abort,
      promise: this.withAuthorization(init)
        .then(init => func(args, init))
        .then(res => res.data)
        .catch(ServiceError.raise),
    };
  }

  exportCWEs(req: { tenant: string }): Call<ExportCWEsResponse> {
    const func = this.fetcher.path("/svc/integrations/{tenant}/cwes/export").method("get").create();
    const args = {
      tenant: req.tenant,
    };

    const { init, abort } = this.withAbort();
    return {
      abort,
      promise: this.withAuthorization(init)
        .then(init => func(args, init))
        .then(res => res.data)
        .catch(ServiceError.raise),
    };
  }

  recordCWEs(req: RecordCWERequest): Call<RecordCWEResponse> {
    const func = this.fetcher.path("/svc/integrations/cwes").method("post").create();

    const { init, abort } = this.withAbort();
    return {
      abort,
      promise: this.withAuthorization(init)
        .then(init => func(req, init))
        .then(res => res.data)
        .catch(ServiceError.raise),
    };
  }

  getCWEReport(req: {
    tenant: string;
    daysBack?: number;
    granularity?: TimelineGranularity;
  }): Call<CWEReportResponse> {
    const func = this.fetcher.path("/svc/integrations/{tenant}/cwes/report").method("get").create();
    const args = {
      tenant: req.tenant,
      daysBack: req.daysBack,
      granularity: req.granularity,
    };

    const { init, abort } = this.withAbort();
    return {
      abort,
      promise: this.withAuthorization(init)
        .then(init => func(args, init))
        .then(res => res.data)
        .catch(ServiceError.raise),
    };
  }
}
